import Message from "../../message";

export default class Test extends Message
{
    handle()
    {
        console.log('RECEIVED TEST MESSAGE', this.message.data);
    }
}
